// gloss
type SubmissionRecord = {
  isApproved: boolean | number | null;
  approvedByUser: string | null;
};

// gloss
export const FAN_MISSION_APPROVAL = {
  PENDING: 0,
  APPROVED: 1,
  DRAFT: 2,
} as const;

export type SubmissionReviewState = 'approved' | 'pending' | 'rejected' | 'draft';

// gloss
export const classifySubmission = (s: SubmissionRecord): SubmissionReviewState => {
  if (s.isApproved === FAN_MISSION_APPROVAL.APPROVED || s.isApproved === true) return 'approved';
  if (s.isApproved === FAN_MISSION_APPROVAL.DRAFT) return 'draft';
  const hasReviewerDecision = !!s.approvedByUser && s.approvedByUser !== 'NULL';
  if ((s.isApproved === FAN_MISSION_APPROVAL.PENDING || s.isApproved === false) && hasReviewerDecision) {
    return 'rejected';
  }
  return 'pending';
};

export type { SubmissionRecord };
